import React, { ReactElement, ReactText } from 'react';
import css from './Heading.module.scss';
import classNames from 'classnames';
import { Mustache } from './Mustache';
import { RoundedIconProps } from '../Icon/RoundedIcon/RoundedIcon.types';

export interface IHeadingProps {
    /** Primary text to display */
    primaryHeading?: string | ReactText[] | React.ReactNode;
    /** Secondary text to display */
    secondaryHeading?: string | ReactText[] | React.ReactNode;
    /** Error to display */
    error?: string | ReactText[];
    /** Hint text to display */
    hint?: string | ReactText[] | JSX.Element;
    /** Icon to display */
    roundedIcon?: ReactElement<RoundedIconProps>;
    /** Whether the mustache should display */
    showMustache?: boolean;
    /** Whether the content should be left aligned */
    leftAlign?: boolean;
}

export const Heading: React.FC<IHeadingProps> = React.memo((props) => (
    <div id={'scrollable-body-heading'} className={classNames(css.heading, props.leftAlign ? css.leftAlign : null, props.roundedIcon ? css.addMarginTopForIcon : null)}>
        {props.roundedIcon && <div id={'scrollable-body-heading-icon'} className={css.icon}>{props.roundedIcon}</div>}
        <div id={'scrollable-body-heading-text'}>
            {props.primaryHeading && <h2 className={css.primary}>{props.primaryHeading}</h2>}
            <div>{props.error && <h4 className={css.error}>{props.error}</h4>}</div>
            {props.secondaryHeading && <h3 className={css.secondary}>{React.Children.toArray(props.secondaryHeading)}</h3>}
        </div>
        <div id={'scrollable-body-heading-hint'}>{props.hint && <h4 className={css.hint}>{props.hint}</h4>}</div>
        {props.showMustache ? <Mustache /> : null}
    </div>
));
